import { render, staticRenderFns } from "./Golden.vue?vue&type=template&id=905dad0e&scoped=true&"
import script from "./Golden.vue?vue&type=script&lang=js&"
export * from "./Golden.vue?vue&type=script&lang=js&"
import style0 from "./Golden.vue?vue&type=style&index=0&id=905dad0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905dad0e",
  null
  
)

export default component.exports